"use client"

import styled from "@emotion/styled"
import Link from "next/link"
import { getNonUmbracoUrl, replaceRichTextLinks } from "utils"
import { DirectionsParkingSignIcon } from "../icons"

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  padding-block: 40px;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 40px;
  }
`

const StyledTitle = styled.h2`
  margin: 0;
  font-size: 28px;
  font-weight: 400;
  line-height: 1.25;
  letter-spacing: -0.8px;
  text-transform: capitalize;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 40px;
  }
`

const StyledTitleBlue = styled.span`
  color: #0000fa;
`

const StyledTitleBlack = styled.span`
  color: ${({ theme }) => theme.colors.port.defaultTextColor};
`

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

const StyledText = styled.div`
  margin: 0;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.port.defaultTextColor};
  width: 100%;

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 18px;
  }

  * {
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
`

const StyledParkingLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.port.defaultTextColor};
  text-decoration: underline;

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
`

type DirectionsSectionProps = {
  blueTitle: string
  blackTitle: string
  text: string
  parkingLink: { name: string; url: string } | null
}

export default function DirectionsSection({
  blueTitle,
  blackTitle,
  text,
  parkingLink,
}: DirectionsSectionProps) {
  if (!text && !parkingLink) return null

  return (
    <StyledSection>
      <StyledTitle>
        <StyledTitleBlue>{blueTitle}</StyledTitleBlue>
        {blackTitle && (
          <>
            {" "}
            <StyledTitleBlack>{blackTitle}</StyledTitleBlack>
          </>
        )}
      </StyledTitle>
      <StyledContent>
        {text && (
          <StyledText
            dangerouslySetInnerHTML={{
              __html: replaceRichTextLinks(text),
            }}
          />
        )}
        {parkingLink?.url && (
          <StyledParkingLink href={getNonUmbracoUrl(parkingLink.url)}>
            <DirectionsParkingSignIcon />
            {parkingLink.name}
          </StyledParkingLink>
        )}
      </StyledContent>
    </StyledSection>
  )
}
